import { loginRequest, graphConfig } from "./authConfig";
import { msalInstance } from "../index";

export async function callMsGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(`${graphConfig.graphMeEndpoint}?$select=displayName,jobTitle,mail,businessPhones,officeLocation,department,companyName`, options)
        .then(response => response.json())
        .catch(error => {});
}

export interface GraphUser {
    id: string;
    displayName: string;
    mail: string;
    userPrincipalName: string;
    jobTitle?: string;
    department?: string;
    officeLocation?: string;
    accountEnabled: boolean;
}

export async function searchGraphUsers(query: string): Promise<GraphUser[]> {
    if (!query || query.trim().length < 2) {
        return [];
    }

    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
        scopes: ["User.Read.All"] // Need broader scope for user search
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    // Search users by display name or email, filtering for active accounts only
    // This excludes terminated users (accountEnabled = false)
    const searchQuery = encodeURIComponent(query.trim());
    const searchUrl = `https://graph.microsoft.com/v1.0/users?$filter=(startswith(displayName,'${searchQuery}') or startswith(mail,'${searchQuery}') or startswith(userPrincipalName,'${searchQuery}')) and accountEnabled eq true&$select=id,displayName,mail,userPrincipalName,jobTitle,department,officeLocation,accountEnabled&$top=10`;

    try {
        const response = await fetch(searchUrl, options);
        const data = await response.json();
        
        // Additional client-side filtering to ensure only active users are returned
        // This provides a double-check in case the server-side filter doesn't work as expected
        const activeUsers = (data.value || []).filter((user: any) => user.accountEnabled === true);
        
        return activeUsers;
    } catch (error) {
        console.error('Error searching users:', error);
        return [];
    }
}